import React, { Component } from 'react';
import NovedadesHelper from '../../../../Common/Helpers/NovedadesHelper';

function strDomicilio(medio, esStore){
    let str = "";
    if(!esStore){
        str += medio.Calle + ' '+medio.Numero+', '+ (medio.Piso ? ("Piso " + medio.Piso + ' Depto. ' + medio.Departamento + " - "):' - ')+ medio.Localidad + ', CP '+ medio.CodigoPostal + ', '+ medio.ProvinciaDescripcion+', '+ medio.PaisDescripcion; 
    }
    return str
}

function mensaje(top,bottom){
    return <div className='mensajeAdvertenciaPostal bottom-separator-xxs'>
        <div className='modalDireccionExistenteBodyText'>{top}</div>
        <div>{bottom}</div>
    </div>
}

class DomicilioExistente extends Component {
    render() { 

        const {data, domiciliosData} = this.props;
       
        let mensajeLegalPrepaga = null;
        let mensajeCorrPrepaga = null;

        let mensajeLegalCredito = null;
        let mensajeCorrCredito = null;

        let checkLegalPrepaga = data.tarjeta_prepaga.some(c=>c.Descripcion == "Legal" && c.Check);
        let checkCorrespondenciaPrepaga = data.tarjeta_prepaga.some(c=>c.Descripcion == "Correspondencia" && c.Check);

        let checkLegalCredito = data.tarjeta_credito.some(c=>c.Descripcion == "Legal" && c.Check);
        let checkCorrespondenciaCredito = data.tarjeta_credito.some(c=>c.Descripcion == "Correspondencia" && c.Check);

        let domNuevo = data.calleEdicion + ' '+data.alturaEdicion+', '+ (data.pisoEdicion ? ("Piso " + data.pisoEdicion + ' Depto. ' + data.deptoEdicion + " - "):' - ')+ data.localidadEdicion +', CP '+ NovedadesHelper.AsignarDescripcionPorId(data.domicilioComponentes.codigoPostalRows || [],data.codigoPostalId) +', ' + NovedadesHelper.AsignarDescripcionPorId(data.domicilioComponentes.provinciaRows || [],data.provinciaId) + ', ' + NovedadesHelper.AsignarDescripcionPorId(data.domicilioComponentes.paisRows || [],data.paisId);
        
        if((domiciliosData.prepagaDomLegalAnterior && checkLegalPrepaga) && !(data.esModificacion && domiciliosData.prepagaDomLegalAnterior.Id == data.domicilioModificacion.Id )){
            mensajeLegalPrepaga = mensaje("La Cuenta Prepaga tiene asociado el domicilio legal:", strDomicilio(domiciliosData.prepagaDomLegalAnterior));            
        } 
        
        if((domiciliosData.prepagaDomCorrespondenciaAnterior && checkCorrespondenciaPrepaga) && !(data.esModificacion && domiciliosData.prepagaDomCorrespondenciaAnterior.Id == data.domicilioModificacion.Id )){
            mensajeCorrPrepaga = mensaje("La Cuenta Prepaga tiene asociado el domicilio para correspondencia:", strDomicilio(domiciliosData.prepagaDomCorrespondenciaAnterior));
        } 

        if((domiciliosData.creditoDomLegalAnterior && checkLegalCredito) && !(data.esModificacion && domiciliosData.creditoDomLegalAnterior.Id == data.domicilioModificacion.Id ) ){
            mensajeLegalCredito = mensaje("La Cuenta Crédito tiene asociado el domicilio legal:", strDomicilio(domiciliosData.creditoDomLegalAnterior));
        } 

        if((domiciliosData.creditoDomCorrespondenciaAnterior && checkCorrespondenciaCredito) && !(data.esModificacion && domiciliosData.creditoDomCorrespondenciaAnterior.Id == data.domicilioModificacion.Id )){
            mensajeLegalCredito = mensaje("La Cuenta Crédito tiene asociado el domicilio para correspondencia:", strDomicilio(domiciliosData.creditoDomCorrespondenciaAnterior));
        } 
    
        return (  
            <div className='modaDireccionExistenteInterior'>
            <div className='modalDireccionExistenteHeader bottom-separator-xxs'>
                <div>¡Atención!</div>
                <label onClick={()=>this.props.funcionCancelar("POSTAL",true)} className='ti-close clickable'></label>
            </div>
            <div className='modalDomicilioExistenteBody'>
               {mensajeLegalPrepaga }
               {mensajeCorrPrepaga}
               {mensajeLegalCredito}
               {mensajeCorrCredito}
                <div className='modalDireccionExistenteBodyText'>Se realizará el reemplazo por el domicilio</div>
                <div className='bottom-separator-xxs'>{domNuevo}</div>
            </div>
            
            <div className='footerTelefonosModal'>
                <button onClick={()=>this.props.funcionCancelar("POSTAL",true)} className='btn btn-secondary'>Cancelar</button>{/*VUELVE AL MODAL DE ALTA DE MAIL*/}
                <button onClick={()=>this.props.funcionAceptar("POSTAL")} className='btn btn-cta'>Aceptar</button>
            </div>
        </div>
       );
    }   
}
export default DomicilioExistente;